/* eslint-disable no-nested-ternary */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useLoggedInUser } from 'api';

import { useCompanyActiveLicence, useLoggedInCompany } from 'api/companyApi';
import { Backend } from 'api/endpoints';

const useOfferActivate = (employmentTypes: Backend.EmploymentType[] = []) => {
	// Token
	const user = useLoggedInUser();

	const { t } = useTranslation('hooks/use_offer_activate/');

	// Company status
	const response = useCompanyActiveLicence(user?.personType === 'ADMIN');
	const offersCount = response.data?.remainingOffers ?? 0;
	const isCompanyActive = response.data?.productType;

	const companyResponse = useLoggedInCompany(user?.personType === 'ADMIN');
	const isCompanyPublic = companyResponse.data?.isPublic;

	return useMemo(
		() =>
			user?.personType === 'ADMIN'
				? undefined
				: !isCompanyActive
				? t('account_active')
				: !isCompanyPublic
				? t('account_public')
				: offersCount === 0 &&
				  employmentTypes.filter(
						e =>
							e !== 'BP' && e !== 'DP' && e !== 'TRAINEE' && e !== 'INTERNSHIP',
				  ).length > 0
				? t('no_offers')
				: undefined,
		[
			user?.personType,
			isCompanyActive,
			isCompanyPublic,
			offersCount,
			employmentTypes,
			t,
		],
	);
};

export default useOfferActivate;
